import { type Meta } from '../types/docs';
import { SKILL_ANALYTICS_SCOPES, SKILL_ANALYTICS_TYPES } from './skillAnalytics';

const META: Meta = {
  description: 'Fired when a skill is published (or re-published) to the workspace scope',
  name: 'skill_published_to_workspace',
  params: [
    {
      description: 'ID of the published skill',
      name: 'skill_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Skill sharing scope after publish',
      name: 'scope',
      required: true,
      type: 'enum',
      values: [...SKILL_ANALYTICS_SCOPES],
    },
    {
      description: 'Skill surface',
      name: 'type',
      required: true,
      type: 'enum',
      values: [...SKILL_ANALYTICS_TYPES],
    },
  ],
};

export default META;
